
import Vue from 'vue'
import errorHandler from '@/utils/errorHandler'
import invoiceReceiptTransformer from '@/transformers/invoiceReceipt'

export default ({customer,taxReceipt}) => {
  const payload = {customer:customer,tax_receipt:taxReceipt}

  return errorHandler(Vue.$http.post('taxreceipt/invoicereceipt/', payload),
     { ignoredKeyNames: ['non_field_errors'] })
    .then((response) => {
      let data = invoiceReceiptTransformer.fetch(response.data)
      return data
    })
}


// WEBPACK FOOTER //
// ./src/services/taxReceipt/createInvoiceReceipt.js